import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { POST_A_QUESTION } from "../../api";
import { AskQuestionCss } from "../../styles/askQuestion";
import { ActionButton, QuestionInput } from "../../styles/communityCommon";

const AskQuestion = () => {
  const [isPosted, setIsPosted] = useState(false);
  const [cookies, setCookie] = useCookies(["authToken"]);
  const [question, setQuestion] = useState("");

  useEffect(() => {
    if (isPosted) {
      setTimeout(() => {
        setIsPosted(false);
      }, 2000);
    }
  }, [isPosted]);

  const submitHandler = () => {
    POST_A_QUESTION(cookies.userID, question)
      .then((res) => {
        console.log("Question posted successfully!!");

        setIsPosted(true);
      })
      .catch((er) => {
        console.log("Error whule posting question", er);
      });
  };
  return (
    <>
      <AskQuestionCss />
      <div className="parent-container">
        {isPosted && <div className="success-msg">Posted Successfully!!</div>}
        {!isPosted && (
          <>
            <QuestionInput
              type="text"
              placeholder="Post your Question here..."
              onChange={(e) => {
                setQuestion(e.target.value);
              }}
            />
            <ActionButton onClick={submitHandler}>Post</ActionButton>
          </>
        )}
      </div>
    </>
  );
};

export default AskQuestion;
